import { memo } from 'react'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'
import Benefit, { BENEFIT_LIST } from './Benefit'

const Benefits = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Container maxWidth="lg">
      <Grid
        container
        spacing={isMobile ? 3 : 5}
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
      >
        {BENEFIT_LIST.map(({ caption, description, icon }, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Grid item key={index}>
            <Benefit caption={caption} description={description} icon={icon} />
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}

export default memo(Benefits)
